import type { BuilderDaSimulacao } from '../../types';
import { executarEntrada } from './actions';

export function registrarEntradasDaConversa(builder: BuilderDaSimulacao): void {
  builder
    .addCase(executarEntrada.pending, (state, action) => {
      const { entrada, via } = action.meta.arg;
      state.envio = {
        simulacaoId: state.simulacao?.id ?? '',
        requestId: action.meta.requestId,
        entrada,
        via,
        status: 'enviando',
        comandoId: via === 'novaTentativa' ? (state.envio?.comandoId ?? null) : null,
        erro: null,
      };
    })
    .addCase(executarEntrada.fulfilled, (state, action) => {
      if (
        state.envio?.requestId !== action.meta.requestId ||
        state.envio.simulacaoId !== action.payload.simulacaoId ||
        state.simulacao?.id !== action.payload.simulacaoId
      )
        return;
      if (state.envio) {
        state.envio.status = 'concluida';
        state.envio.comandoId = action.payload.comandoId;
      }
      if (state.simulacao?.id === action.payload.simulacaoId) {
        state.simulacao = action.payload.estado;
      }
    })
    .addCase(executarEntrada.rejected, (state, action) => {
      if (
        state.envio?.requestId !== action.meta.requestId ||
        state.envio.simulacaoId !== action.meta.simulacaoId ||
        state.simulacao?.id !== action.meta.simulacaoId
      )
        return;
      if (!state.envio || !action.payload) return;
      // O comando já não está FALHOU (concluiu ou está rodando): repetir não tem efeito.
      if (action.payload.codigo === 'COMANDO_NAO_FALHOU') {
        state.envio.status = 'concluida';
        return;
      }
      state.envio.status = 'falhou';
      state.envio.erro = action.payload;
      // Sem o comando no core, a nova tentativa daria o mesmo 404: o retry reenvia como intenção nova.
      state.envio.comandoId =
        action.payload.codigo === 'COMANDO_NAO_ENCONTRADO'
          ? null
          : (action.payload.comandoId ?? state.envio.comandoId);
    });
}
